import {createSelector} from 'reselect';
import {getDeliveryOptionsMessaging} from './DeliveryOptionsSelectors';

export default createSelector(
  [getDeliveryOptionsMessaging],
  (deliveryOptionsMessaging) => {
    if (deliveryOptionsMessaging) {
      const pondErrorMsg = deliveryOptionsMessaging['73'] ? deliveryOptionsMessaging['73'][0] : null;
      return pondErrorMsg || null;
    }
    return null;
  },
);
